import { render, staticRenderFns } from "./GarageDoor.vue?vue&type=template&id=01645c2c&scoped=true"
import script from "./GarageDoor.vue?vue&type=script&lang=ts"
export * from "./GarageDoor.vue?vue&type=script&lang=ts"
import style0 from "./GarageDoor.vue?vue&type=style&index=0&id=01645c2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01645c2c",
  null
  
)

export default component.exports